import React from "react";
import { Link } from "react-router-dom";
import { InstagramLogo, YoutubeLogo, ArrowUpRight } from "@phosphor-icons/react";

export default function Footer() {
    return (
        <footer className="bg-[#0A0A0A] border-t border-zinc-800 mt-32" data-testid="site-footer">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="font-display text-5xl md:text-6xl tracking-tight text-white leading-none">
                            TIZONA<span className="text-[#FFD000]">.</span>TECH
                        </div>
                        <p className="mt-6 text-zinc-400 max-w-md leading-relaxed">
                            Sharp takes on the gear, code, and ideas shaping tomorrow. Built by tinkerers, for tinkerers.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="overline mb-5">Sections</div>
                        <ul className="space-y-3 text-sm font-medium uppercase tracking-wider text-zinc-300">
                            <li><Link to="/category/news" className="hover:text-[#FFD000]">News</Link></li>
                            <li><Link to="/category/reviews" className="hover:text-[#FFD000]">Reviews</Link></li>
                            <li><Link to="/category/features" className="hover:text-[#FFD000]">Features</Link></li>
                            <li><Link to="/category/videos" className="hover:text-[#FFD000]">Videos</Link></li>
                            {/* Tizona Trends footer link masked per user request */}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="overline mb-5">Follow Tizona</div>
                        <a href="https://www.youtube.com/channel/UCK7IwwD0gvvompUwdg09GmA" target="_blank" rel="noreferrer"
                           data-testid="footer-youtube-link"
                           className="group flex items-center justify-between border border-zinc-800 hover:border-[#FFD000] p-4 mb-3 transition-colors">
                            <span className="flex items-center gap-3 text-white">
                                <YoutubeLogo size={22} weight="bold" />
                                <span className="font-bold uppercase tracking-wider text-sm">YouTube</span>
                            </span>
                            <ArrowUpRight size={18} className="text-zinc-500 group-hover:text-[#FFD000] group-hover:rotate-45 transition-transform" />
                        </a>
                        <a href="https://www.instagram.com/tizonatech" target="_blank" rel="noreferrer"
                           data-testid="footer-instagram-link"
                           className="group flex items-center justify-between border border-zinc-800 hover:border-[#FFD000] p-4 transition-colors">
                            <span className="flex items-center gap-3 text-white">
                                <InstagramLogo size={22} weight="bold" />
                                <span className="font-bold uppercase tracking-wider text-sm">Instagram</span>
                            </span>
                            <ArrowUpRight size={18} className="text-zinc-500 group-hover:text-[#FFD000] group-hover:rotate-45 transition-transform" />
                        </a>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-600">
                        &copy; {new Date().getFullYear()} Tizona Tech — All Rights Reserved
                    </div>
                    <div className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-600">
                        Made with sharp edges &amp; strong opinions
                    </div>
                </div>
            </div>
        </footer>
    );
}
